import { fetchServer } from "@/features/utils/fetch";
import { StandardResponse } from "@/features/utils/types";
import {
  companyAdminListType,
  LegalEntityAdminCreateSchema,
  legalEntityUpdateSituation
} from "../types";
import { companyAdminNewListType } from "@/features/company/types";

export class AdminApiClient {
  static async fetchAdminListOfCompanies(
    page?: number,
    limit?: number,
    legal_name?: string
  ): Promise<StandardResponse<companyAdminListType[]> & { hasMore: boolean; count: number }> {
    try {
      const response = await fetchServer(
        legal_name
          ? `/admin/company/list?page=${page}&limit=${limit}&legal_name=${legal_name}`
          : `/admin/company/list?page=${page}&limit=${limit}`,
        {
          method: "GET"
        }
      );
      if (!response.ok) throw new Error("Error");
      const res = await response.json();

      return res;
    } catch (_) {
      return {
        success: false,
        data: [],
        hasMore: false,
        count: 0
      };
    }
  }
  static async fetchAdminNewListOfCompanies(
    showAll: boolean,
    page?: number,
    limit?: number,
    legal_name?: string
  ): Promise<StandardResponse<companyAdminNewListType[]> & { hasMore: boolean; count: number }> {
    try {
      const response = await fetchServer(
        legal_name
          ? `/admin/company/list/new?page=${page}&limit=${limit}&legal_name=${legal_name}&show_all=${
              showAll ? 1 : 0
            }`
          : `/admin/company/list/new?page=${page}&limit=${limit}&show_all=${showAll ? 1 : 0}`,
        {
          method: "GET"
        }
      );
      if (!response.ok) throw new Error("Error");
      const res = await response.json();

      return res;
    } catch (_) {
      return {
        success: false,
        data: [],
        hasMore: false,
        count: 0
      };
    }
  }

  static addAdminCompanyInfo = async (data: LegalEntityAdminCreateSchema) => {
    const response = await fetchServer("/admin/company", {
      method: "POST",
      reloadOn401: false,
      mainRoot: false,
      body: data
    });
    if (!response.ok) throw new Error("Error");
    return response.json();
  };
  static editCompanySituation = async (data: legalEntityUpdateSituation) => {
    const response = await fetchServer(`/admin/company/${data.companyUuid}/situation`, {
      method: "PUT",
      reloadOn401: false,
      mainRoot: false,
      body: {
        situation: data.situation
      }
    });
    if (!response.ok) throw new Error("Error");
    return response.json();
  };
}
